var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as Styles from './styles.css';
import DatePicker from 'antd/lib/date-picker';
import Form from 'antd/lib/form';
import InputNumber from 'antd/lib/input-number';
import Select from 'antd/lib/select';
import React, { useCallback, useEffect, useState } from 'react';
import { CustomerRegister, DaumMap, DialogComponent, AntPrimaryGhostButton, CustomerSegmentContainer, useGlobalModal, ButtonWithPlusCircle, FullWidthButton, HiddenSubmitButton, Icon, typographyByName } from 'renderer/components';
import { ClickableText, TextComponent } from 'renderer/components/Typography';
import DaumPostcode from 'react-daum-postcode';
import TextArea from 'antd/lib/input/TextArea';
import clsx from 'clsx';
import { CustomerQuery, QUERY_CACHE } from 'renderer/queries';
import { convertHexToRgbA, useDebounce } from 'renderer/utils';
import * as dayjs from 'dayjs';
import { COLORS } from 'renderer/styles';
import Checkbox from 'antd/lib/checkbox';
import TimePicker from 'antd/lib/time-picker';
import Cascader from 'antd/lib/cascader';
import Row from 'antd/lib/row';
import Radio from 'antd/lib/radio';
import Input from 'antd/lib/input';
import Col from 'antd/lib/col';
import Spin from 'antd/lib/spin';
import Empty from 'antd/lib/empty';
import { REGEX_NUMBER_FORMMATER, REGEX_NUMBER_PARSER, REGEX_NUMBER_PARSER_ALLOW_NEGATIVE } from 'renderer/constants';
import { isPlussharpMobileApp } from 'renderer/utils';
import styled, { css } from 'styled-components';
import { useRecoilState } from 'recoil';
import { Atoms } from 'renderer/stores/atoms';
var StyledDatePicker = styled(DatePicker)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n", "} \n& input {\n  ", "} \n}\n"], ["\n", "} \n& input {\n  ", "} \n}\n"])), css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), typographyByName('caption1')), css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), typographyByName('caption1')));
export var suffixFormatter = function (value, unit) {
    var isNegative = value < 0;
    var absValue = Math.abs(value);
    var formattedValue = "".concat(Math.floor(absValue)).concat(unit).replace(REGEX_NUMBER_FORMMATER, ',');
    return isNegative ? "-".concat(formattedValue) : formattedValue;
};
export var seperateNumber = function (value) {
    if (value === undefined)
        return '';
    if (value === null)
        return '';
    if (value === '')
        return '';
    var isNegative = value < 0;
    var absValue = Math.abs(value);
    var formattedValue = "".concat(Math.floor(absValue)).replace(REGEX_NUMBER_FORMMATER, ',');
    return isNegative ? "-".concat(formattedValue) : formattedValue;
};
export var InputByType = function (props) {
    var type = props.type, inputProps = props.inputProps, rest = __rest(props, ["type", "inputProps"]);
    var isApp = isPlussharpMobileApp();
    switch (props.type) {
        case 'text':
            return React.createElement(Input, __assign({}, inputProps));
        case 'textarea':
            return React.createElement(TextArea, __assign({}, inputProps));
        case 'number':
            return (React.createElement(NumberFormatInput, __assign({ formatter: seperateNumber, parser: function (value) {
                    var _a;
                    return value.replace(((_a = props.inputProps) === null || _a === void 0 ? void 0 : _a.allowNegative) ? REGEX_NUMBER_PARSER_ALLOW_NEGATIVE : REGEX_NUMBER_PARSER, '');
                } }, inputProps)));
        case 'password':
            return (React.createElement(Input.Password, __assign({}, inputProps, { iconRender: function (visible) { return (visible ? React.createElement(Icon, { name: "eye" }) : React.createElement(Icon, { name: "eye-off" })); } })));
        case 'checkbox':
            return React.createElement(Checkbox, __assign({}, inputProps));
        case 'select':
            return React.createElement(Select, __assign({}, inputProps, { showSearch: false }));
        case 'radio':
            return React.createElement(Radio.Group, __assign({}, inputProps));
        case 'timepicker':
            return React.createElement(TimePickerAutoaccept, __assign({ inputReadOnly: isApp }, inputProps, { showNow: false }));
        case 'datepicker':
            return React.createElement(DatePickerAutoaccept, __assign({ inputReadOnly: isApp }, inputProps, { showNow: false }));
        case 'rangepicker':
            return React.createElement(DatePicker.RangePicker, __assign({}, inputProps));
        case 'monthpicker':
            return React.createElement(DatePicker.MonthPicker, __assign({}, inputProps));
        case 'address':
            return React.createElement(AddressInput, __assign({}, inputProps));
        case 'customerSearch':
            return React.createElement(CustomerSearchInput, __assign({}, inputProps));
        case 'color':
            return React.createElement(ColorSelect, __assign({}, inputProps));
        case 'cascader':
            return React.createElement(Cascader, __assign({}, inputProps));
        case 'birth':
            return React.createElement(BirthInput, __assign({}, inputProps));
        case 'inlineGroup':
            return (React.createElement(Input.Group, { compact: true }, inputProps.inputPropsArray.map(InputByType)));
    }
};
export var RenderField = function (field, index) {
    var rightElement = field.rightElement, leftElement = field.leftElement, fields = field.fields, element = field.element, itemProps = field.itemProps, rowClassName = field.rowClassName, wrap = field.wrap, rest = __rest(field, ["rightElement", "leftElement", "fields", "element", "itemProps", "rowClassName", "wrap"]);
    if (element) {
        // FIXME: add key
        return element;
    }
    switch (rest.type) {
        case 'inlineGroup':
            if (fields) {
                return (React.createElement(Row, { wrap: wrap, key: "".concat(itemProps === null || itemProps === void 0 ? void 0 : itemProps.name, "_").concat(index) }, fields.map(function (item, index) {
                    var _a;
                    var rightElement = item.rightElement, leftElement = item.leftElement, element = item.element, itemProps = item.itemProps, rowClassName = item.rowClassName, rest = __rest(item, ["rightElement", "leftElement", "element", "itemProps", "rowClassName"]);
                    return item.element ? (item.element) : (React.createElement(StyledFormItem, __assign({}, item.itemProps, { className: clsx((_a = item.itemProps) === null || _a === void 0 ? void 0 : _a.className), key: "inlineGroup_".concat(itemProps === null || itemProps === void 0 ? void 0 : itemProps.name, "_").concat(index) }), InputByType(rest)));
                })));
            }
        default:
            return (React.createElement(Row, { key: "".concat(itemProps === null || itemProps === void 0 ? void 0 : itemProps.name, "_").concat(index), className: clsx('ant-form-item', rowClassName), wrap: false, gutter: 8 },
                leftElement && leftElement,
                React.createElement(Col, { flex: "auto" },
                    React.createElement(StyledFormItem, __assign({}, field.itemProps, { className: clsx(itemProps === null || itemProps === void 0 ? void 0 : itemProps.className) }), InputByType(rest))),
                rightElement && rightElement));
    }
};
export var AntdForm = function (props) {
    var layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
    };
    return (React.createElement(Form, __assign({}, layout, props.formProps, { 
        // FOR styled-components
        className: props.className, noValidate: true, colon: false, labelAlign: "left" }),
        props.fields.filter(Boolean).map(RenderField),
        props.submitButton && (React.createElement(Row, { justify: "end", wrap: false },
            React.createElement(FullWidthButton, { type: "primary", htmlType: "submit" }, props.submitButton))),
        props.allowEnterSubmit && React.createElement(HiddenSubmitButton, null)));
};
export var AddressInput = function (props) {
    var onComplete = props.onComplete, rest = __rest(props, ["onComplete"]);
    var _a = React.useState(false), visiblePostcode = _a[0], setVisiblePostcode = _a[1];
    var inputProps = __assign({ readOnly: true }, rest);
    var handleClick = function () {
        setVisiblePostcode(true);
    };
    var _b = React.useState(), inputValue = _b[0], setInputValue = _b[1];
    // React.useEffect(() => {
    //   if (inputValue !== props.value) {
    //     setInputValue(props.value);
    //   }
    // }, [props.value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(NoBottomMarginRow, { gutter: 8, wrap: false },
            React.createElement(Col, { flex: 1 },
                React.createElement(Input, __assign({}, inputProps, { onClick: props.withoutButton && handleClick }))),
            !props.withoutButton && (React.createElement(Col, null,
                React.createElement(AntPrimaryGhostButton, { children: "\uC8FC\uC18C\uAC80\uC0C9", onClick: handleClick })))),
        React.createElement(DialogComponent, { zIndex: 9999, onClose: function () { return setVisiblePostcode(false); }, visible: visiblePostcode, title: "\uC8FC\uC18C\uCC3E\uAE30", destroyOnClose: true, content: React.createElement(DaumPostcode, { onComplete: function (addressResult) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        DaumMap.Geocoder().addressSearch(addressResult.address, function (result, status) {
                            var target = result && result[0];
                            if (status === 'OK' && target) {
                                if (onComplete) {
                                    onComplete({ address: addressResult, latLng: { latitude: target.y, longitude: target.x } });
                                }
                                else {
                                    if (props.onChange) {
                                        props.onChange({
                                            address: addressResult,
                                            latLng: { latitude: target.y, longitude: target.x }
                                        });
                                    }
                                }
                                // TODO: 좌표 없을 떄는 ??
                            }
                            setVisiblePostcode(false);
                        });
                        return [2 /*return*/];
                    });
                }); } }) })));
};
var NoBottomMarginRow = styled(Row)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: 0px !important;\n"], ["\n  margin-bottom: 0px !important;\n"])));
export var CustomerSearchInput = React.forwardRef(function (props, ref) {
    var store = QUERY_CACHE.getQueryData(['store']);
    var storeId = store === null || store === void 0 ? void 0 : store.id;
    var _a = React.useState(props.value), keyword = _a[0], setKeyword = _a[1];
    var debouncedKeyword = useDebounce(keyword, 500);
    var _b = CustomerQuery.useCustomerPager({
        storeId: storeId,
        limit: 20,
        page: 1,
        search: ["name:".concat(debouncedKeyword), "phone:".concat(debouncedKeyword)]
    }, { enabled: !!debouncedKeyword && !!storeId }), pagerResult = _b.pagerResult, isLoading = _b.isLoading, setNewPagerOptions = _b.setNewPagerOptions;
    React.useEffect(function () {
        setNewPagerOptions({
            storeId: storeId,
            limit: 20,
            page: 1,
            search: ["name:".concat(debouncedKeyword), "phone:".concat(debouncedKeyword)]
        });
        setNewCustomer(undefined);
    }, [debouncedKeyword]);
    var customerModal = useGlobalModal();
    var isDetailOpen = !!customerModal.getState();
    var _c = React.useState(), newCustomer = _c[0], setNewCustomer = _c[1];
    var _d = React.useState(), customerRegisterDrawer = _d[0], setCustomerRegisterDrawer = _d[1];
    var customers = newCustomer ? [newCustomer] : pagerResult.items || [];
    var prevCustomerQuery = CustomerQuery.useCustomerDetail({ id: props.value, storeId: storeId }, { enabled: false });
    React.useEffect(function () {
        var _a, _b, _c;
        if (props.value &&
            !((_a = pagerResult === null || pagerResult === void 0 ? void 0 : pagerResult.items) === null || _a === void 0 ? void 0 : _a.find(function (customer) { return customer.id === props.value; })) &&
            !props.isDeletedCustomer) {
            var data = CustomerQuery.customerDetailQuery({ id: props.value, storeId: storeId });
            if ((_b = data.state) === null || _b === void 0 ? void 0 : _b.data) {
                setNewCustomer((_c = data.state) === null || _c === void 0 ? void 0 : _c.data);
            }
            else {
                prevCustomerQuery.refetch().then(function (data) {
                    if (data.data) {
                        setNewCustomer(data.data);
                    }
                });
            }
        }
    }, [props.value]);
    var _e = useState(false), openState = _e[0], setOpenState = _e[1];
    var isHeader = props.isHeader;
    var _f = useRecoilState(Atoms.headerSearcherState), headerSearcherState = _f[0], setHeaderSearcherState = _f[1];
    var setOpen = useCallback(function (value) {
        if (isHeader) {
            setHeaderSearcherState(function (prev) { return (__assign(__assign({}, prev), { isSelectOpen: value })); });
        }
        setOpenState(value);
    }, [isHeader, setHeaderSearcherState]);
    useEffect(function () {
        if (typeof props.open === 'boolean' && openState !== props.open) {
            setOpenState(props.open);
        }
    }, [props.open]);
    useEffect(function () {
        if (isHeader) {
            setOpenState(headerSearcherState.isFocused);
        }
    }, [isHeader, headerSearcherState.isFocused]);
    var hideControlButtons = props.hideControlButtons, isDeletedCustomer = props.isDeletedCustomer, rest = __rest(props, ["hideControlButtons", "isDeletedCustomer"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledAntSelect, __assign({ style: { width: '100%' } }, rest, { open: openState, ref: ref, onDropdownVisibleChange: function (open) {
                setOpen(open);
                if (props.onDropdownVisibleChange) {
                    props.onDropdownVisibleChange(open);
                }
            }, onKeyDown: function (event) {
                var _a, _b;
                if (event.keyCode === 13) {
                    event.preventDefault();
                    event.stopPropagation();
                    if ((pagerResult === null || pagerResult === void 0 ? void 0 : pagerResult.items) && ((_a = pagerResult === null || pagerResult === void 0 ? void 0 : pagerResult.items) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                        if (props.onChange) {
                            props.onChange((_b = pagerResult === null || pagerResult === void 0 ? void 0 : pagerResult.items[0]) === null || _b === void 0 ? void 0 : _b.id, {});
                        }
                    }
                    else {
                        setOpen(true);
                        if (props.onDropdownVisibleChange) {
                            props.onDropdownVisibleChange(true);
                        }
                    }
                }
            }, placeholder: props.placeholder || (React.createElement(React.Fragment, null,
                React.createElement(Icon, { name: "search" }),
                "\u00A0 \uACE0\uAC1D\uBA85 \uB610\uB294 \uC5F0\uB77D\uCC98 \uAC80\uC0C9")), showSearch: true, value: props.value, defaultActiveFirstOption: false, notFoundContent: isLoading && debouncedKeyword ? (React.createElement(Spin, { size: "small" })) : (React.createElement(Empty, { description: !keyword ? '고객명 또는 연락처 검색' : '고객을 찾을 수 없습니다.' })), optionLabelProp: "label", onSearch: setKeyword, filterOption: false, dropdownRender: function (menu) {
                return props.hideAddButton ? (menu) : (React.createElement("div", null,
                    React.createElement(ButtonWithPlusCircle, { children: "\uC2E0\uADDC \uACE0\uAC1D \uCD94\uAC00", style: { width: '100%', zIndex: 10000 }, onClick: function (ev) {
                            ev.stopPropagation();
                            ev.preventDefault();
                            setOpen(false);
                            if (typeof props.onDropdownVisibleChange === 'function') {
                                props === null || props === void 0 ? void 0 : props.onDropdownVisibleChange(false);
                            }
                            setCustomerRegisterDrawer({});
                        } }),
                    menu));
            }, dropdownStyle: {
                display: openState ? 'block' : 'none'
            } }), props.isDeletedCustomer && props.value ? (React.createElement(Select.Option, { value: props.value, key: props.value, label: '삭제된 고객' }, "\uC0AD\uC81C\uB41C \uACE0\uAC1D")) : (customers.filter(Boolean).map(function (customer) {
            var name = "".concat(customer.name || '', " - ").concat(customer.phoneToString || '');
            return (React.createElement(Select.Option, { value: customer.id, key: customer.id, label: name },
                name,
                React.createElement(CustomerSegmentContainer, { items: CustomerQuery.getCustomerSegments(customer) })));
        }))),
        props.hideDetailButton ||
            (props.value && !isDetailOpen && !props.isDeletedCustomer && (React.createElement(ClickableText, { marginTop: 10, onClick: function () {
                    customerModal.open({
                        type: 'customerDetail',
                        data: {
                            customerId: props.value,
                            hideControlButtons: hideControlButtons
                        }
                    });
                }, children: "\uACE0\uAC1D\uC815\uBCF4 \uD655\uC778 >", color: COLORS.primary1 }))),
        React.createElement(CustomerRegister, { storeId: storeId, data: customerRegisterDrawer, onClose: function (customer) {
                if (props.onChange && (customer === null || customer === void 0 ? void 0 : customer.id)) {
                    setNewCustomer(customer);
                    props.onChange(customer === null || customer === void 0 ? void 0 : customer.id, {});
                }
                setCustomerRegisterDrawer(undefined);
            } })));
});
CustomerSearchInput.displayName = 'CustomerSearchInput';
var StyledAntSelect = styled(Select)(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
export var StyledCustonerSearchInput = styled(CustomerSearchInput)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  & .ant-select-arrow {\n    display: none;\n  }\n"], ["\n  & .ant-select-arrow {\n    display: none;\n  }\n"])));
export var BirthInput = function (props) {
    var onComplete = props.onComplete, rest = __rest(props, ["onComplete"]);
    var _a = React.useState({}), data = _a[0], setData = _a[1];
    React.useEffect(function () {
        var _a = props.value || {}, y = _a.y, m = _a.m, d = _a.d;
        if (y && m && d) {
            setData({ y: y, m: m, d: d });
        }
    }, [props.value]);
    var handleChange = function (name, value) {
        var newData = __assign({}, data);
        newData[name] = value;
        setData(newData);
        var y = newData.y, m = newData.m, d = newData.d;
        if (y && m && d) {
            var newDate = dayjs("".concat(y, "-").concat(m, "-").concat(d)).toDate();
            props.onChange(newDate);
            onComplete(newDate);
        }
        else {
            onComplete('Invalid Date');
        }
    };
    return (React.createElement(Row, { gutter: 8 },
        React.createElement(Col, { span: 10 },
            React.createElement(Row, { align: "middle", wrap: false, gutter: 4 },
                React.createElement(Col, { flex: 1 },
                    React.createElement(InputNumber, { maxLength: 4, type: "tel", name: "y", onChange: function (value) { return handleChange('y', value); }, max: 2999, min: 1800 })),
                React.createElement(Col, null, "\uB144"))),
        React.createElement(Col, { span: 7 },
            React.createElement(Row, { align: "middle", wrap: false, gutter: 4 },
                React.createElement(Col, { flex: 1 },
                    React.createElement(InputNumber, { maxLength: 2, type: "tel", name: "m", onChange: function (value) { return handleChange('m', value); }, max: 12, min: 1 })),
                React.createElement(Col, null, "\uC6D4"))),
        React.createElement(Col, { span: 7 },
            React.createElement(Row, { align: "middle", wrap: false, gutter: 4 },
                React.createElement(Col, { flex: 1 },
                    React.createElement(InputNumber, { maxLength: 2, type: "tel", name: "d", onChange: function (value) { return handleChange('d', value); }, max: 31, min: 1 })),
                React.createElement(Col, null, "\uC77C"))),
        React.createElement(Input, __assign({}, rest, { className: Styles.dateInput }))));
};
export var StyledFormItem = styled(Form.Item)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  & label {\n    ", "}\n    margin-right: 8px;\n    visibility: ", ";\n  }\n  & > div {\n    max-width: 100%;\n  }\n  & .dateInput {\n    display: none;\n  }\n  & .ant-form-item-label {\n    text-align: left;\n  }\n  & .ant-select-selection-overflow {\n    gap: 4px 4px;\n    & .ant-tag {\n      margin-inline-end: 0;\n    }\n  }\n  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n    margin-right: 0px;\n    content: '';\n    display: none !important;\n  }\n  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {\n    content: '*';\n    display: inline-block;\n    margin-right: 4px;\n    ", "}\n    line-height: 1;\n  }\n  @media (max-width: 575px) {\n    .ant-form-item-control {\n      flex: 2 !important;\n    }\n    .ant-form-item-label {\n      flex: 1 !important;\n    }\n  }\n"], ["\n  & label {\n    ", "}\n    margin-right: 8px;\n    visibility: ", ";\n  }\n  & > div {\n    max-width: 100%;\n  }\n  & .dateInput {\n    display: none;\n  }\n  & .ant-form-item-label {\n    text-align: left;\n  }\n  & .ant-select-selection-overflow {\n    gap: 4px 4px;\n    & .ant-tag {\n      margin-inline-end: 0;\n    }\n  }\n  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n    margin-right: 0px;\n    content: '';\n    display: none !important;\n  }\n  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {\n    content: '*';\n    display: inline-block;\n    margin-right: 4px;\n    ", "}\n    line-height: 1;\n  }\n  @media (max-width: 575px) {\n    .ant-form-item-control {\n      flex: 2 !important;\n    }\n    .ant-form-item-label {\n      flex: 1 !important;\n    }\n  }\n"])), css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), typographyByName('caption1')), function (props) { return (props.isHiddenLabel ? 'hidden' : 'visible'); }, css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), typographyByName('caption1')));
export var FormItemLabel = styled(TextComponent).attrs({
    type: 'subtitle2',
    color: COLORS.gray3,
    marginBottom: 10
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  &:after {\n    content: ", ";\n    display: inline-block;\n    margin-right: 4px;\n    color: ", ";\n    font-size: 14px;\n    font-family: SimSun, sans-serif;\n    line-height: 1;\n  }\n"], ["\n  &:after {\n    content: ", ";\n    display: inline-block;\n    margin-right: 4px;\n    color: ", ";\n    font-size: 14px;\n    font-family: SimSun, sans-serif;\n    line-height: 1;\n  }\n"])), function (props) { return (props.required ? '*' : ''); }, COLORS.gray3);
export var NumberFormatInput = styled(InputNumber).attrs({
    type: 'tel'
    // formatter: seperateNumber,
    // parser: (value) => value.replace(REGEX_NUMBER_PARSER, '')
})(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  & input {\n    text-align: right !important;\n    padding-right: 12px !important;\n  }\n\n  &.ant-input-number-affix-wrapper {\n    width: 100%;\n    & input {\n      padding-right: 24px !important;\n    }\n  }\n\n  & .ant-input-number-handler-wrap {\n    display: none;\n  }\n"], ["\n  & input {\n    text-align: right !important;\n    padding-right: 12px !important;\n  }\n\n  &.ant-input-number-affix-wrapper {\n    width: 100%;\n    & input {\n      padding-right: 24px !important;\n    }\n  }\n\n  & .ant-input-number-handler-wrap {\n    display: none;\n  }\n"])));
export var ColorSelect = function (props) {
    var options = props.options ||
        [
            { value: COLORS.tag1, label: "1" },
            { value: COLORS.tag2, label: "1" },
            { value: COLORS.tag3, label: "1" },
            { value: COLORS.tag4, label: "1" },
            { value: COLORS.tag5, label: "1" },
            { value: COLORS.tag6, label: "1" },
            { value: COLORS.tag7, label: "1" }
        ].map(function (item) {
            return {
                value: item.value,
                label: React.createElement(ColorLabel, { color: item.value })
            };
        });
    return (React.createElement(ColorSelectStyle, __assign({ popupMatchSelectWidth: false }, props, { options: options, dropdownRender: function (menu) {
            return (React.createElement(ColorWrapper, null, options.map(function (option) {
                return (React.createElement(ColorItem, { key: option.value, color: option.value, onClick: function () { return props.onChange(option.value, {}); } }));
            })));
        } })));
};
var ColorLabel = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 2px;\n  width: 100%;\n  padding: 10px 0px;\n  margin-top: 5px;\n"], ["\n  background-color: ", ";\n  border-radius: 2px;\n  width: 100%;\n  padding: 10px 0px;\n  margin-top: 5px;\n"])), function (props) { return props.color; });
var ColorSelectStyle = styled(Select)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  & > .ant-select-selector {\n    border-radius: 4px;\n    box-shadow: 0 0 5px 0 var(--primary-shadow);\n    border: solid 1px var(--gray-6);\n    background-color: ", " !important;\n  }\n"], ["\n  & > .ant-select-selector {\n    border-radius: 4px;\n    box-shadow: 0 0 5px 0 var(--primary-shadow);\n    border: solid 1px var(--gray-6);\n    background-color: ", " !important;\n  }\n"])), function (props) { return props.value || '#ffffff'; });
var ColorWrapper = styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  display: flex;\n  padding: 10px;\n  min-width: 100px;\n"], ["\n  display: flex;\n  padding: 10px;\n  min-width: 100px;\n"])));
var ColorItem = styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  background-color: ", ";\n  width: 24px;\n  height: 24px;\n  border-radius: 2px;\n  margin-right: 6px;\n  cursor: pointer;\n  border: solid 1px ", ";\n\n  &:last-child {\n    margin-right: 0px;\n  }\n"], ["\n  background-color: ", ";\n  width: 24px;\n  height: 24px;\n  border-radius: 2px;\n  margin-right: 6px;\n  cursor: pointer;\n  border: solid 1px ", ";\n\n  &:last-child {\n    margin-right: 0px;\n  }\n"])), function (props) { return props.color; }, function (props) { return (props.isSelected ? COLORS.primaryFocus : convertHexToRgbA(props.color, 0.2)); });
export var DatePickerAutoaccept = function (props) {
    var onTimepickerBlur = function (hhmm) {
        var value = dayjs("".concat(dayjs(props.value).format('YYYY-MM-DD'), " ").concat(hhmm));
        if (value && value.isValid() && props.onChange) {
            props.onChange(value, hhmm);
        }
    };
    var _a = props, showTime = _a.showTime, rest = __rest(_a, ["showTime"]);
    return showTime ? (React.createElement(Row, { gutter: 8 },
        React.createElement(Col, { span: 16 },
            React.createElement(StyledDatePicker, __assign({}, rest, { suffixIcon: null, format: 'YYYY-MM-DD', needConfirm: false, onChange: function (date) {
                    var hhmm = dayjs(props.value).format('HH:mm');
                    var value = dayjs("".concat(dayjs(date).format('YYYY-MM-DD'), " ").concat(hhmm));
                    if (value && value.isValid() && props.onChange) {
                        props.onChange(value);
                    }
                } }))),
        React.createElement(Col, { span: 8 },
            React.createElement(TimePicker, __assign({}, props, { format: 'HH:mm', suffixIcon: true, needConfirm: false, onChange: function (value) {
                    onTimepickerBlur(value.format('HH:mm'));
                }, renderExtraFooter: function () { return React.createElement("div", null); } }))))) : (React.createElement(StyledDatePicker, __assign({}, props, { needConfirm: false })));
};
export var RadioGroup = function (props) {
    var _a;
    return (React.createElement(Radio.Group, null, (_a = props.options) === null || _a === void 0 ? void 0 : _a.map(function (option) {
        return (React.createElement(Radio, { key: "".concat(option.value), value: option.value }, option.label));
    })));
};
export var TimePickerAutoaccept = function (props) {
    return React.createElement(TimePicker, __assign({}, props, { needConfirm: false }));
};
export var PhoneNumberNormalizer = function (str) {
    if (!str) {
        return '';
    }
    var temp = str.replace(/-/g, '');
    if (temp.length <= 10) {
        return str
            .replace(/[^0-9]/g, '')
            .replace(/([0-9]{3})([0-9]{3})?([0-9]+)$/, '$1-$2-$3')
            .replace('--', '-');
    }
    else {
        return str
            .replace(/[^0-9]/g, '')
            .replace(/([0-9]{3})([0-9]{4})([0-9]+)$/, '$1-$2-$3')
            .replace('--', '-');
    }
};
export var BizNumberNormalizer = function (str) {
    var temp = str.replace(/-/g, '');
    if (temp.length < 6) {
        return str
            .replace(/[^0-9]/g, '')
            .replace(/([0-9]{3})([0-9]{1,2})$/, '$1-$2')
            .replace('--', '-');
    }
    else {
        return str
            .replace(/[^0-9]/g, '')
            .replace(/([0-9]{3})([0-9]{2})?([0-9]+)$/, '$1-$2-$3')
            .replace('--', '-');
    }
};
export var FormItemWithoutInput = styled(Form.Item)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  margin-bottom: 0px !important;\n  margin-top: 5px;\n  & .ant-form-item-control-input {\n    min-height: 0px !important;\n  }\n"], ["\n  margin-bottom: 0px !important;\n  margin-top: 5px;\n  & .ant-form-item-control-input {\n    min-height: 0px !important;\n  }\n"])));
export var KeywordSearcher = function (props) {
    var _a = React.useState(''), typedKeyword = _a[0], setKeyword = _a[1];
    var debouncedKeyword = useDebounce(typedKeyword, 500);
    React.useEffect(function () {
        if ((debouncedKeyword || debouncedKeyword === '') && debouncedKeyword !== props.value) {
            props.onChange(debouncedKeyword);
        }
    }, [debouncedKeyword]);
    React.useEffect(function () {
        if (props.value !== debouncedKeyword) {
            setKeyword(props.value);
        }
    }, [props.value]);
    return (React.createElement(SearchInput, { size: 'large', prefix: React.createElement(Icon, { name: "search" }), value: typedKeyword, placeholder: props.placeholder, onChange: function (event) { return setKeyword(event.target.value); } }));
};
var SearchInput = styled(Input)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  width: 200px;\n  margin-right: 10px;\n"], ["\n  width: 200px;\n  margin-right: 10px;\n"])));
export var DropdownRenderButton = function (_a) {
    var text = _a.text, onClick = _a.onClick;
    return (React.createElement(StyledDropdownRenderButton, { title: text, onClick: onClick },
        React.createElement(Icon, { size: 16, name: "plus-circle", color: COLORS.primary1 }),
        React.createElement(TextComponent, { type: "body2", style: {
                fontWeight: 600,
            }, color: COLORS.primary1 }, text)));
};
export var StyledDropdownRenderButton = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  border-radius: 4px;\n  padding: 0 15px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n  transition: background-color 0.3s ease;\n  cursor: pointer;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n  &:active {\n    background-color: rgba(0, 0, 0, 0.15);\n  }\n"], ["\n  border-radius: 4px;\n  padding: 0 15px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n  transition: background-color 0.3s ease;\n  cursor: pointer;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n  &:active {\n    background-color: rgba(0, 0, 0, 0.15);\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;
